import React from 'react'
import PropTypes from 'prop-types'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

import './TextareaInput.scss'

const TextareaInput = ({
  id,
  label,
  password,
  name,
  value,
  placeholder,
  onChange,
  onBlur,
  onKeyDown,
  disabled,
  required,
  'aria-required': ariaRequired,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
}) => {
  const fieldId = id || name
  const isRequired = required || ariaRequired

  return (
    <div
      className={`amd-areatext-input-container ${
        !label ? 'amd-text-input-container-no-label' : ''
      }`}
    >
      <textarea
        className="form-control amd-areatext-input"
        type={password ? 'password' : 'text'}
        id={fieldId}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        disabled={disabled ? 'true' : undefined}
        rows="3"
        required={isRequired}
        aria-required={isRequired}
        aria-invalid={ariaInvalid}
        aria-describedby={ariaDescribedBy}
      />
      <label
        className={`amd-areatext-input-label amd-areatext-area-label ${
          value ? 'amd-areatext-area-label-active' : ''
        }`}
        htmlFor={fieldId}
      >
        <FormattedMessage id={label} />
        {isRequired && (
          <span className="required-indicator" aria-hidden="true">
            *
          </span>
        )}
        {isRequired && <span className="sr-only">(required)</span>}
      </label>
    </div>
  )
}

TextareaInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  password: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  required: PropTypes.bool,
  'aria-required': PropTypes.bool,
  'aria-invalid': PropTypes.bool,
  'aria-describedby': PropTypes.string,
}

export default TextareaInput
